__webpack_require__.p = "/wp-content/themes/starwarps-2026/dist/";